import { MouseEvent, RefObject } from "react";

import { isNull } from "lodash";

import { FieldGroups, FieldTypes, FieldWidth, IBoomformField, IField, Selected } from "./../store/fields/types";
import { IFieldInitial, fieldInitials } from "./../store/fields/initails";
import {
    AddressInput,
    ContentType,
    IFieldSelectData,
    IFieldInputData,
    AlignmentTypes,
    LabelAlignmentTypes,
    WidthMeasurement,
    TextAlignmentTypes,
} from "./../store/fields/boomtypes";
import { IColorData } from "../store/ui/types";
import { mergeObjects } from "./dataManipulations";
import { fieldsInitials } from "./dataManipulations/initials";

export const getFieldsByGroup = (group: FieldGroups): IFieldInitial[] =>
    fieldInitials.filter(field => field.group === group);

export const getFieldByType = (type: IField["type"]): IFieldInitial =>
    fieldInitials.filter(field => field.type === type)[0];

export const widthForInput = [0, 25, 50, 75, 100];

export const getFieldWidth = (value: number, parentWidth: number) => {
    const resizedWidth = (value * 100) / parentWidth;
    let fieldWidth: FieldWidth = FieldWidth.Full;

    if (resizedWidth >= widthForInput[FieldWidth.AlmostFull] + 10) fieldWidth = FieldWidth.Full;
    else if (
        resizedWidth >= widthForInput[FieldWidth.Half] + 10 &&
        resizedWidth < widthForInput[FieldWidth.AlmostFull] + 10
    )
        fieldWidth = FieldWidth.AlmostFull;
    else if (resizedWidth >= widthForInput[FieldWidth.Half] - 10 && resizedWidth < widthForInput[FieldWidth.Half] + 10)
        fieldWidth = FieldWidth.Half;
    else if (resizedWidth < widthForInput[FieldWidth.Half] - 10) fieldWidth = FieldWidth.PartOfHalf;

    return { fieldWidth, width: widthForInput[fieldWidth] };
};

export const validateHundred = (value: string, disable: boolean) =>
    value.trim() === "" || (!disable && Number(value) >= 0 && Number(value) <= 100);

export const chngeWithFieldType = (
    handleChange: Function,
    fieldId: IField["_id"] | string,
    fieldType: FieldTypes | null,
    valueKey: string,
    value: any,
    inputType?: string | null | Selected,
) => {
    if (typeof inputType === "string") {
        switch (fieldType) {
            case FieldTypes.NAME:
                if (inputType === Selected.All) {
                    handleChange({ id: `temp.${fieldId}.${Selected.MULTI}.input.${valueKey}`, value: value });

                    handleChange({ id: `fields.${fieldId}.first_name.${valueKey}.input`, value: value });
                    handleChange({ id: `fields.${fieldId}.middle_name.${valueKey}.input`, value: value });
                    handleChange({ id: `fields.${fieldId}.last_name.${valueKey}.input`, value: value });
                } else {
                    handleChange({ id: `fields.${fieldId}.${inputType}.${valueKey}`, value: value });
                }
                break;

            case FieldTypes.ADDRESS:
                if (inputType === Selected.All) {
                    handleChange({ id: `temp.${fieldId}.${Selected.MULTI}.input.${valueKey}`, value: value });

                    handleChange({
                        id: `fields.${fieldId}.${AddressInput.STREET_ADDRESS}.input.${valueKey}`,
                        value: value,
                    });
                    handleChange({
                        id: `fields.${fieldId}.${AddressInput.STREET_ADDRESS_TWO}.input.${valueKey}`,
                        value: value,
                    });
                    handleChange({ id: `fields.${fieldId}.${AddressInput.CITY}.input.${valueKey}`, value: value });
                    handleChange({ id: `fields.${fieldId}.${AddressInput.STATE}.input.${valueKey}`, value: value });
                    handleChange({ id: `fields.${fieldId}.${AddressInput.ZIP_CODE}.input.${valueKey}`, value: value });
                    handleChange({
                        id: `fields.${fieldId}.${AddressInput.SELECT_COUNTRY}.input.${valueKey}`,
                        value: value,
                    });
                } else {
                    handleChange({ id: `fields.${fieldId}.${inputType}.${valueKey}`, value: value });
                }
                break;
            default:
                handleChange({ id: `fields.${fieldId}.input.${valueKey}`, value: value });
                break;
        }
    } else {
        handleChange({ id: `fields.${fieldId}.${valueKey}`, value: value });
    }
};

export const getInputByIdAndFieldType = (id: string, fieldType: FieldTypes | null, inputType: string | null) => {
    let element = null;

    switch (fieldType) {
        case FieldTypes.NAME:
        case FieldTypes.ADDRESS:
            element = document.getElementById(`${id}.${inputType}.input`);
            break;
        default:
            element = document.getElementById(`${id}.input`);
            break;
    }

    return element;
};

interface IChangeFieldMinWidthOption {
    isMiddleName: boolean;
}

export const changeFieldMinWidth = (id: number, type: FieldTypes, options: IChangeFieldMinWidthOption) => {
    const { isMiddleName } = options;
    const minWidthIds = {
        2: "minWidth2",
        3: "minWidth3",
    };
    let minWidthId = "";

    switch (type) {
        case FieldTypes.NAME:
            if (isMiddleName) minWidthId = minWidthIds[3];
            else minWidthId = minWidthIds[2];
            break;
    }

    const fieldParentElement = document.getElementById(`field-${id}`)?.parentElement;
    if (fieldParentElement?.id !== minWidthId) fieldParentElement?.setAttribute("id", minWidthId);
};
const isObject = (value: any) => {
    return !!(value && typeof value === "object" && !Array.isArray(value));
};

interface IDeclarableField {
    [key: string]: any;
}

export const getDeclarableValues = (neededValues: IDeclarableField, id: IField["_id"]) => {
    let value: IDeclarableField = {};
    const iterate = (obj: IDeclarableField, stack: string) => {
        for (let property in obj)
            if (isObject(obj[property]) && property !== "color" && property !== "center" && property !== "markers")
                iterate(obj[property], `${stack ? stack : id}.${property}`);
            else value[`fields.${stack ? stack : id}.${property}`] = obj[property];
    };

    iterate(neededValues, "");
    return value;
};

export const getDeclarableField = (
    fieldType: FieldTypes,
    id: IField["_id"],
    isInit: boolean,
    data?: Partial<IBoomformField & IField>,
) => {
    const clonedInitials = mergeObjects(fieldsInitials[fieldType], data || {});

    let newField = {};
    if (data && isInit) {
        delete data._id;
        delete data.updatedAt;
        delete data.createdAt;
        delete data.type;

        newField = getDeclarableValues(data, id);
    } else newField = getDeclarableValues(clonedInitials, id);
    return newField;
};

export enum MailOrLink {
    MAIL,
    LINK,
}

interface IOnChangeMailOrLinkData {
    contentType: ContentType;
    placeholder: string;
    isActive: boolean;
    handleChange: ({ id, value }: { id: string; value: any }) => void;
    id: string;
    customId: string;
    changeType: MailOrLink;
    changeableContentType?: ContentType;
}

export const onChangeMailOrLink = ({
    contentType,
    placeholder,
    isActive,
    handleChange,
    id,
    customId,
    changeType,
    changeableContentType = ContentType.PLACEHOLDER,
}: IOnChangeMailOrLinkData) => {
    const isChangeable =
        (contentType === ContentType.PLACEHOLDER && placeholder === "Placeholder") ||
        contentType === ContentType.DEFAULT_TEXT ||
        isActive;

    if (isChangeable || changeableContentType === ContentType.DEFAULT_TEXT) {
        handleChange({ id: customId, value: !Boolean(isActive) });
        handleChange({
            id: `fields.${id}.validation.${changeType === MailOrLink.MAIL ? "link" : "mail"}`,
            value: false,
        });

        let value = "Placeholder";
        if (!Boolean(isActive)) {
            switch (changeType) {
                case MailOrLink.MAIL:
                    value = "example@example.com";
                    break;
                case MailOrLink.LINK:
                    value = "https://www.example.com";
                    break;
            }
        } else {
            switch (changeableContentType) {
                case ContentType.PLACEHOLDER:
                    value = "Placeholder";
                    break;
                case ContentType.DEFAULT_TEXT:
                    value = " ";
                    break;
            }
        }

        handleChange({
            id: `fields.${id}.input.data.${changeableContentType}`,
            value,
        });
    }
};

export const getRatingValueWithElement = (e: MouseEvent<HTMLDivElement>, itemValue: number): number => {
    const target = e.target as HTMLButtonElement;
    const rect = target.getBoundingClientRect();
    const x = Math.floor(e.clientX - rect.left);
    // const targetHalf = Math.floor(target.clientWidth / 2);
    let minus = 0;

    if (x === 0) minus = 1;
    // minus vaiable was using for detecting half selected star
    // else if (x < targetHalf) minus = 0.5;

    return itemValue - minus;
};

export const checkInputsSpacing = <FIELD>(
    fieldData: FIELD,
    inputs: Array<keyof FIELD>,
    wrapperBox?: RefObject<HTMLDivElement>,
): { [key: string]: boolean } => {
    const isHaveSpacing: { [key: string]: boolean } = {};
    const inputsInRows: { [key: number]: Array<keyof FIELD> } = {};
    let row = 0;

    const getInputWidthWithFieldData = (_inputType: keyof FIELD): number => {
        let inputData: any = fieldData[_inputType] as FIELD[keyof FIELD];
        inputData = inputData["input"] as IFieldSelectData | IFieldInputData;
        const widthMeasurement = inputData["styles"]["input"]["widthMeasurement"];
        const widthPx = inputData["styles"]["input"][`widthPx`];
        let newWidth = Number(inputData["styles"]["input"][`width${widthMeasurement}`]) || 100;

        if (wrapperBox && wrapperBox?.current && widthMeasurement === WidthMeasurement.PX) {
            if (isNaN(widthPx) || isNull(widthPx)) {
                newWidth = Number(inputData["styles"]["input"][`widthPercent`]);
            } else {
                const fieldWidthPX = wrapperBox.current ? wrapperBox.current.clientWidth : 0;
                newWidth = newWidth * (100 / fieldWidthPX);
            }
        }
        return newWidth;
    };

    inputs.forEach(inputType => {
        if (inputsInRows[row]) {
            const inputWidth = getInputWidthWithFieldData(inputType);
            let checkwidth = 0;

            inputsInRows[row].forEach((rowInputType: keyof FIELD) => {
                checkwidth += getInputWidthWithFieldData(rowInputType as keyof FIELD);
            });
            checkwidth += inputWidth;

            if (checkwidth > 100) {
                row++;
                inputsInRows[row] = [inputType];
            } else {
                inputsInRows[row].push(inputType);
            }
        } else inputsInRows[row] = [inputType];
    });

    Object.values(inputsInRows).forEach(inputsInRow => {
        if (inputsInRow.length === 1) isHaveSpacing[inputsInRow[0] as string] = false;
        else inputsInRow.forEach((_inputType: keyof FIELD) => (isHaveSpacing[_inputType as string] = true));
    });

    return isHaveSpacing;
};

export const getStyleWithAlignmentType = (type: AlignmentTypes): string => {
    switch (type) {
        case AlignmentTypes.LEFT:
            return "flex-start";
        case AlignmentTypes.CENTER:
            return "center";
        case AlignmentTypes.RIGHT:
            return "flex-end";
        default:
            return "flex-start";
    }
};
export const getTextStyleWithAlignmentType = (type: AlignmentTypes): TextAlignmentTypes => {
    switch (type) {
        case AlignmentTypes.LEFT:
            return TextAlignmentTypes.START;
        case AlignmentTypes.CENTER:
            return TextAlignmentTypes.CENTER;
        case AlignmentTypes.RIGHT:
            return TextAlignmentTypes.END;
        default:
            return TextAlignmentTypes.START;
    }
};

export const getStyleWithAlignItemType = (type: AlignmentTypes): string => {
    switch (type) {
        case AlignmentTypes.LEFT:
            return "start";
        case AlignmentTypes.CENTER:
            return "center";
        case AlignmentTypes.RIGHT:
            return "end";
        default:
            return "start";
    }
};

export const getLabelStyleWithAlignmentType = (type: LabelAlignmentTypes): string => {
    switch (type) {
        case LabelAlignmentTypes.TOP_LEFT:
            return "flex-start";
        case LabelAlignmentTypes.TOP_RIGHT:
            return "";
        case LabelAlignmentTypes.TOP_CENTER:
            return "center";
        default:
            return "start";
    }
};

export const getLabelValueAlignment = (type: LabelAlignmentTypes): string => {
    switch (type) {
        case LabelAlignmentTypes.TOP_LEFT:
            return "left";
        case LabelAlignmentTypes.TOP_CENTER:
            return "center";
        case LabelAlignmentTypes.TOP_RIGHT:
            return "right";
        case LabelAlignmentTypes.LEFT:
            return "left";
        case LabelAlignmentTypes.RIGHT:
            return "right";
        default:
            return "start";
    }
};

export const isFontSizeMixed = (checkID: string): { isMixed: boolean; tempValue: number | null } => {
    const fields = window.__current_form_state.values.fields;
    const ids = Object.keys(fields);
    const isInput = checkID.includes("inputValue");
    let tempValue = isInput ? fields[ids[0]].input.styles.inputValue.size : fields[ids[0]].label.styles.size;

    let isMixed = false;
    if (isInput) {
        ids.forEach(id => {
            const {
                input: {
                    styles: {
                        inputValue: { size: value },
                    },
                },
            } = fields[id];
            if (+tempValue !== +value) {
                isMixed = true;
            }
        });
    } else {
        ids.forEach(id => {
            const {
                label: {
                    styles: { size: value },
                },
            } = fields[id];
            if (+tempValue !== +value) {
                isMixed = true;
            }
        });
    }
    if (isMixed) tempValue = null;
    return { isMixed, tempValue };
};

enum ColorPickerModes {
    SOLID,
    GRADIENT,
    IMAGE,
}
export const getCorrectBackground = (style: IColorData): any => {
    const type = style.lastModified.type as unknown as ColorPickerModes;

    switch (type) {
        case ColorPickerModes.SOLID: {
            return { background: style.lastModified.style };
        }
        case ColorPickerModes.GRADIENT: {
            return { background: style.lastModified.style };
        }
        case ColorPickerModes.IMAGE: {
            const backgroundStyles = {
                backgroundImage: `url(${style.imageUrl})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
            };
            return backgroundStyles;
        }
    }
};
